<div class="home-bg add-70">
    <div class="container">
        <div class="page-banner home-banner">
            <div class="row align-items-center flex-wrap h-100">
                <div class="col-md-6 py-5 wow fadeInLeft hero-block">
                    <h1 class="mb-4 font-700 hero-text">Upgrade to Simplicity</h1>
                    <p class="mb-4 hero-subtext">Manage everything in a single system</p>
                    <button type="button" class="btn brand-button" routerLink="/product/journey">Simplify now</button>
                </div>
                <div class="col-md-6 py-5 hero-image-parent">
                    <img src="assets/img/hero_image.png" class="hero-image" alt="Doctor observing his workflows being synced and simplified" srcset="">
                </div>
            </div>
        </div>
    </div>
</div>

<app-client-marquee></app-client-marquee>
<!-- USPs -->
<div class="page-section" id="">
    <div class="container">
        <!-- Loop through all USPs -->
        <ng-container *ngFor="let usp of usps; let i = index">
            <ng-container *ngIf="i % 2 == 0">
                <div class="row align-items-center flex-wrap h-100 usp-row">
                    <div class="col-md-7 col-12">
                        <h3 class="font-700">{{usp.header}}</h3>
                        <p class="mb-4">{{usp.sub_header}}</p>
                        <button type="button" class="btn brand-button" routerLink="/product/usp">{{usp.button}}</button>
                    </div>
                    <div class="col-md-5 col-12 mobile-usp-image">
                        <img [src]="usp.img" [alt]="usp.alt" class="usp-image usp-right">
                    </div>
                </div>
                <div style="display: grid" *ngIf="i < usps.length-1">
                    <div class="divider"></div>
                </div>
            </ng-container>
            <!-- Flip on odd items -->
            <ng-container *ngIf="i % 2 == 1">
                <div class="row align-items-center flex-wrap h-100 usp-row odd-col">
                    <div class="col-md-5 col-12 mobile-usp-image">
                        <img [src]="usp.img" [alt]="usp.alt" class="usp-image">
                    </div>
                    <div class="col-md-7 col-12 move-right">
                        <h3 class="font-700">{{usp.header}}</h3>
                        <p class="mb-3">{{usp.sub_header}}</p>
                        <button type="button" class="btn brand-button" routerLink="/product/usp">{{usp.button}}</button>
                    </div>
                </div>
                <div style="display: grid" *ngIf="i < usps.length-1">
                    <div class="divider"></div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>

<!-- One system to manage all -->
<div class="page-section reduce-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 py-12 center-align wow fadeInUp">
                <h2 class="font-700 mb-5">One System to Manage All</h2>
            </div>
        </div>
    </div>

    <!-- Accordion menu for modules -->
    <div class="container">
        <div class="row align-items-center flex-wrap h-100 usp-row">
            <div class="col-lg-4 col-12">
                <ngb-accordion [closeOthers]="true" activeIds="static-2" (panelChange)="enableHospitalState($event)">
                    <ngb-panel id="static-1" title="Hospital OS" >
                        <ng-template ngbPanelContent>
                            Streamline your hospital with our all-in-one system. Ditch paper-based systems and effortlessly manage patient records, appointments, billing, and more.
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="static-2" >
                        <ng-template ngbPanelTitle>
                            <span>Clinic OS</span>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            Solution designed for clinics and independent physician practice. It offers electronic health records, medical billing, patient engagement tools, telemedicine functionality, patient charts, reputation management, and financial analytics.
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="static-3" title="Pharmacy OS" >
                        <ng-template ngbPanelContent>
                            An ultimate solution for chemists, pharma, and medicine retailers. With a complete range of features including complete POS functionality, inventory and stock management, expiry and breakage management, accounting, GST e-filing, and flexible reporting, this software can help pharmacies boost their efficiency, cut down on errors, and improve profitability.
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="static-4" title="Lab OS" >
                        <ng-template ngbPanelContent>
                            Designed to streamline and manage laboratory processes. It typically includes features such as sample tracking, results reporting, quality control, and inventory management. By providing a centralised platform for managing laboratory data, it can improve patient outcomes and reduce costs associated with errors or delays in testing.
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="static-5" title="Radiology OS" >
                        <ng-template ngbPanelContent>
                            Specialized in managing a radiology department or imaging center. Its features include patient management, imaging workflow, PACS integration, billing, reporting, quality control, EMR integration, analytics, and security. Its aim is to enhance workflow management, efficiency, and patient care.
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="static-6" title="Medical Institute OS" >
                        <ng-template ngbPanelContent>
                            Our tailored medical institute software simplifies student data management, financial tracking, and clinical rotation scheduling. It automates operations, reduces costs, and offers robust reporting tools. With seamless integration and data protection compliance, we empower institutions to focus on their core mission of providing quality education and patient care.
                        </ng-template>
                    </ngb-panel>
                </ngb-accordion>
            </div>
            <div class="col-lg-8 col-12 side-section">
                <img ngSrc="assets/img/3d/3d_hospital.webp" style="position: relative !important;" alt="hospital" srcset="" *ngIf="hospital_state == 'static-1' || hospital_state == 'static-6'" fill>
                <img ngSrc="assets/img/3d/3d_clinic.webp" style="position: relative !important;" alt="clinic" srcset="" *ngIf="hospital_state == 'static-2'" fill>
                <img ngSrc="assets/img/3d/3d_pharmacy.webp" style="position: relative !important;" alt="pharmacy" srcset="" *ngIf="hospital_state == 'static-3'" fill>
                <img ngSrc="assets/img/3d/3d_lab.webp" style="position: relative !important;" alt="lab" srcset="" *ngIf="hospital_state == 'static-4'" fill>
                <img ngSrc="assets/img/3d/3d_radio.webp" style="position: relative !important;" alt="radiology" srcset="" *ngIf="hospital_state == 'static-5'" fill>
            </div>
        </div>
        
        <div class="row">
            <div class="col text-center">
                <button type="button" class="btn brand-button" routerLink="/product/usp">Take a Tour</button>
            </div>
        </div>

    </div>
</div>

<!-- Testimonials Header -->
<div class="page-section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 py-12 center-align wow fadeInUp">
                <h2 class="font-700 mb-5">Witness our Efforts here</h2>
            </div>
        </div>
        <swiper [config]="config">
            <div class="swiper-wrapper" style="overflow: visible !important;">
                <ng-container *ngFor="let testimonial of testimonials">
                    <div class="swiper-slide" style="box-sizing: border-box;">
                        <app-testimonial-card [testimonial]="testimonial"></app-testimonial-card>
                    </div>
                </ng-container>
            </div>
           
            <!-- Add Pagination -->
            <div class="swiper-pagination" aria-hidden="true"></div>
        </swiper>
    </div>
</div>
<div class="page-section">
    <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12 py-12 center-align wow fadeInUp">
              <h2 class="font-700 mb-5">Recognized by the Best, Providing the Best</h2>
          </div>
        </div>
        <div class="row align-items-center">
            <div class="col text-center software-icons">
                <a href="https://www.capterra.com/reviews/281306/Nuvertos?utm_source=vendor&utm_medium=badge&utm_campaign=capterra_reviews_badge%22%3E">
                    <img border="0" src="https://assets.capterra.com/badge/7611bf89fc71ea322f3ec5333de9d8ff.svg?v=2228845&p=281306" /> 
                </a>
                <!-- <img src="assets/img/capterra-grey.webp" alt="Capterra Logo" aria-hidden="true"> -->
            </div>
            <div class="col text-center software-icons">
                <a href="https://www.softwareadvice.com/clinical-trial-management/nuvertos-profile/">
                    <img border="0" src="https://badges.softwareadvice.com/reviews/3614f9ec-20ea-4773-967f-d842be47d2d1" /> 
                </a>
                <!-- <img src="assets/img/software_suggest.webp" alt="SoftwareSuggest Logo" aria-hidden="true"> -->
            </div>
        </div>
    </div>
</div>



<app-contact-card></app-contact-card>